// Shared date-range presets for every chat picker (reservations, reports...).
// To add a new shortcut, add ONE entry here, then list its id in the
// `presetIds` prop of the <PeriodPicker /> that should show it.
// Weeks start on Sunday (US locale, same as the rest of the app).

const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

const startOfWeek = () => addDays(new Date(), -new Date().getDay());

const monthRange = (offset) => {
  const n = new Date();
  return [iso(new Date(n.getFullYear(), n.getMonth() + offset, 1)), iso(new Date(n.getFullYear(), n.getMonth() + offset + 1, 0))];
};

export const isoToday = () => iso(new Date());
export const isoPlusDays = (n) => iso(addDays(new Date(), n));

export const DATE_PRESETS = {
  today: { label: "Today", range: () => [isoToday(), isoToday()] },
  thisWeek: { label: "This week", range: () => [iso(startOfWeek()), iso(addDays(startOfWeek(), 6))] },
  prevWeek: { label: "Previous week", range: () => [iso(addDays(startOfWeek(), -7)), iso(addDays(startOfWeek(), -1))] },
  nextWeek: { label: "Next week", range: () => [iso(addDays(startOfWeek(), 7)), iso(addDays(startOfWeek(), 13))] },
  thisMonth: { label: "This month", range: () => monthRange(0) },
  prevMonth: { label: "Previous month", range: () => monthRange(-1) },
  nextMonth: { label: "Next month", range: () => monthRange(1) },
};
